import React from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import CustomerListResults from '../components/company/CustomerListResults';
import CustomerListToolbar from '../components/company/CustomerListToolbar';
// import customers from '../__mocks__/customers';

const CustomerList = () => {
  const [companies, seCompanies] = React.useState();

  React.useEffect(async () => {
    try {
      // handleToggle(true);
      await axios
        .get('saas', {
          config: { handlerEnabled: true }
        })
        .then((response) => {
          console.log(response);
          seCompanies(response.data.data);
          // setNewLearner({
          //   ...newLearner,
          //   name: "",
          //   email: "",
          // });
          // handleToggle(false);
          // setAllLearners(response.data.data);
          // setMessage(response.data.message);
        });
    } catch (e) {
      // handleToggle(false);
      if (e.response && e.response.data) {
        // setMessage(e.response.data.message);
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Companies</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <CustomerListToolbar />
          <Box sx={{ pt: 3 }}>
            {companies && <CustomerListResults companies={companies} />}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CustomerList;
